export default {
  getFirewallConfig: state => state.firewallConfig,
  getIpsBlocked: state => state.ipsBlocked,
}
